import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import { CompanyTabsWrapper } from '../Tabs';

const companyWrapperPropertyTypes = {
  profile: PropTypes.shape({
    brands: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
    }).isRequired).isRequired,
  }).isRequired,
  children: PropTypes.node.isRequired,
};

type CompanyWrapperProperties = InferProps<typeof companyWrapperPropertyTypes>;

const CompanyWrapper = ({
  children,
  profile,
}: CompanyWrapperProperties) => (
  <>
    <CompanyTabsWrapper profile={profile} />
    {children}
  </>
);

CompanyWrapper.propTypes = companyWrapperPropertyTypes;

export default CompanyWrapper;
